module.exports = __webpack_public_path__ + "static/media/arturo@3x.9f2cc733.jpg";